<template>
  <transition name="modal-fade">
    <v-dialog v-model="shown" persistent max-width="500">
      <v-card>
        <v-card-title class="pl-2 headline">
          SEQITracker Anmeldung (via Moco)
        </v-card-title>

        <section class="modal-authentication-body">
          <v-select
            v-if="storedEnvironments.length > 0"
            v-model="selectedEnvironment"
            :items="storedEnvironments"
            label="Gespeicherte Umgebung laden"
            item-text="display"
            return-object
            dense
            outlined
            prepend-inner-icon="mdi-content-save-all"
            class="mb-2"
            @change="selectEnvironment"
          ></v-select>

          <slot name="body">
            <v-text-field v-model="mocoEmail" @keydown.enter="login" label="Moco Benutzer (Email)" placeholder="vorname.nachname@seqis.com" dense :autofocus="!mocoEmail"></v-text-field>
            <v-text-field v-model="mocoAPIKey" @keydown.enter="login" label="Moco API-Key" type="password" dense :autofocus="!!mocoEmail"></v-text-field>
            <v-text-field v-model="mocoEnv" @keydown.enter="login" label="Moco Umgebung" placeholder="seqis/razzfazz" dense></v-text-field>
            <v-row>
              <v-col cols="12">
                <label class="red--text">{{ errorMessage }}</label>
              </v-col>
            </v-row>
          </slot>
        </section>

        <v-card-actions class="justify-space-between">
          <v-btn type="button" @click="closeDialog" :disabled="!canClose" color="#c00000" class="white--text">
            Schließen
          </v-btn>
          <v-btn type="button" @click="login" :loading="this.loading" :disabled="!mocoEmail || !mocoAPIKey" color="#c00000" class="white--text">
            Anmelden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </transition>
</template>

<script>
  import * as mocoClient from '@client/client.moco.js'
  import persistentStore from '@store/persistentStore';

  export default {
    name: 'AuthenticationDialog',
    data() {
      const authenticated = this.$store.getters.userAuthenticationData.authenticated ?? false;
      return {
        shown: true,
        mocoEmail: authenticated ? '' : this.$store.getters.userAuthenticationData.email,
        mocoEnv: authenticated ? '' : this.$store.getters.userAuthenticationData.mocoEnv,
        mocoAPIKey: authenticated ? '' : this.$store.getters.userAuthenticationData.mocoApiKey,
        mocoUserID: authenticated ? '' : this.$store.getters.userAuthenticationData.mocoUserID,
        selectedEnvironment: null,
        storedEnvironments: [],
        canClose: authenticated,
        errorMessage: undefined,
        loading: false
      }
    },
    
    created() {
      this.storedEnvironments = persistentStore.getStoredEnvs().map(environment => ({
        ...environment,
        display: `${environment.mocoEnv}`
      }));

      this.selectedEnvironment = this.storedEnvironments.find(storedEnv => storedEnv.mocoEnv === this.mocoEnv) ?? null;
    },

    methods: {
      async login() {
        this.errorMessage = undefined;
        if (this.mocoEmail == '' || this.mocoAPIKey == '') {
          return;
        }

        try {
          this.loading = true;
          const mocoSession = await mocoClient.createMocoSession(this.mocoEmail, this.mocoAPIKey, this.mocoEnv);
          this.$emit('authenticated', {
            email: this.mocoEmail,
            mocoUserID: mocoSession.userID,
            mocoApiKey: this.mocoAPIKey,
            mocoEnv: this.mocoEnv
          });
        } catch(e) {
          this.errorMessage = 'Moco Email oder API-Key falsch :-(';
        }
        this.loading = false;
      },

      selectEnvironment(environment) {
        this.mocoEmail = environment.email;
        this.mocoAPIKey = environment.mocoApiKey;
        this.mocoEnv = environment.mocoEnv;
      },

      closeDialog() {
        this.$emit('close');
      }
    }
  };
</script>

<style>
  .modal-authentication-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9998;
  }

  .modal-authentication {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 350px;
  }

  .modal-authentication-header,
  .modal-authentication-footer {
    padding: 15px;
    display: flex;
  }

  .modal-authentication-header {
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-authentication-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-authentication-body {
    overflow: hidden; /* Hide scrollbar */
    position: relative;
    padding: 20px 10px;
  }
</style>